var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33325C5.42004 1.33325 3.33337 3.41992 3.33337 5.99992C3.33337 7.15992 3.66671 8.24659 4.27337 9.22659C4.90671 10.2533 5.74004 11.1333 6.38004 12.1599C6.69337 12.6599 6.92004 13.1266 7.16004 13.6666C7.33337 14.0333 7.47337 14.6666 8.00004 14.6666C8.52671 14.6666 8.66671 14.0333 8.83337 13.6666C9.08004 13.1266 9.30004 12.6599 9.61337 12.1599C10.2534 11.1399 11.0867 10.2599 11.72 9.22659C12.3334 8.24659 12.6667 7.15992 12.6667 5.99992C12.6667 3.41992 10.58 1.33325 8.00004 1.33325ZM8.00004 7.83325C7.08004 7.83325 6.33337 7.08659 6.33337 6.16659C6.33337 5.24659 7.08004 4.49992 8.00004 4.49992C8.92004 4.49992 9.66671 5.24659 9.66671 6.16659C9.66671 7.08659 8.92004 7.83325 8.00004 7.83325Z",
    fill: "#323743"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin1);
export default __webpack_public_path__ + "static/media/location-pin-1.0f86004eb45ac9e44d5c526ca92eebaa.svg";
export { ForwardRef as ReactComponent };